/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { ITechnologyAreaDataState } from "Interfaces/SiteContent/ITechnologyAreaDataState";

import {
  IGetTechnologyAreaFailure,
  IGetTechnologyAreaSuccess,
} from "../TechnologyArea/TechnologyAreaAction";
import { TECHAREADATA_LOAD_FAILURE, TECHAREADATA_LOAD_SUCCESS } from "./TechnologyAreaTypes";

export const initialState: ITechnologyAreaDataState = {
  technologyAreaLoadError: "",
  technologyAreaData: [],
};

/**
 * Updates state of fetch technology area success.
 * @param {ITechnologyAreaDataState} state The technology area state.
 * @param {IGetTechnologyAreaSuccess} action The technology area action success.
 * @returns {ITechnologyAreaDataState} New technology area state.
 */
const applyLoadTechnologyAreas = (
  state: ITechnologyAreaDataState,
  action: IGetTechnologyAreaSuccess
): ITechnologyAreaDataState => {
  return {
    ...state,
    technologyAreaData: action.technologyAreaOptionList,
  };
};

/**
 * Updates state of fetch technology area failure.
 * @param {ITechnologyAreaDataState} state The technology area state.
 * @param {IGetTechnologyAreaFailure} action The technology area action failure.
 * @returns {ITechnologyAreaDataState} New technology area state.
 */
const applyLoadFailTechnologyAreas = (
  state: ITechnologyAreaDataState,
  action: IGetTechnologyAreaFailure
): ITechnologyAreaDataState => ({
  ...state,
  technologyAreaLoadError: action.technologyAreaLoadError,
});

/**
 * Reducer function for technology area options.
 * @param state technology area state.
 * @param action action.
 * @returns {ITechnologyAreaDataState} New technology area state.
 */
function technologyAreaReducer(
  state: ITechnologyAreaDataState = initialState,
  action
): ITechnologyAreaDataState {
  switch (action.type) {
    case TECHAREADATA_LOAD_SUCCESS:
      return applyLoadTechnologyAreas(state, action);
    case TECHAREADATA_LOAD_FAILURE:
      return applyLoadFailTechnologyAreas(state, action);
    default:
      return state;
  }
}

export default technologyAreaReducer;
